import { LeftDataPanel } from './LeftDataPanel.jsx';
import { ChartPanel } from './ChartPanel.jsx';
import { CustomizePanel } from './CustomizePanel.jsx';

export function Workspace() {
  return (
    <div className="workspace" id="workspace">
      <LeftDataPanel />
      <div
        className="workspace-split"
        id="splitLeft"
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize left panel"
        title="Drag to resize"
      />
      <ChartPanel />
      <div
        className="workspace-split"
        id="splitRight"
        role="separator"
        aria-orientation="vertical"
        aria-label="Resize right panel"
        title="Drag to resize"
      />
      <CustomizePanel />
    </div>
  );
}
